<template>
	<v-dialog v-model="dialog" content-class="delete-contextual-dialog">
		<v-card class="pa-6 text-center">
			<h1 class="big">
				Are you sure you want to<br />
				remove {{ userName }} from {{ groupName }}?
			</h1>
			<div class="actions mt-8">
				<v-btn width="145" height="45" class="mx-2" color="primary" @click="$emit('cancel')">Cancel</v-btn>
				<v-btn width="145" height="45" class="mx-2" style="color: #e94e4e; background: #fde9e9" @click="$emit('ok')">Yes</v-btn>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'DeleteGroupDialog',
	props: {
		showDialog: { type: Boolean },
		groupName: { type: String },
		userName: { type: String },
	},
	watch: {
		showDialog: {
			handler(newV) {
				if (newV) {
					this.localDialog = true;
				}
			},
		},
		localDialog: {
			handler(newV) {
				this.$emit('update:showDialog', newV);
			},
		},
	},
	computed: {
		dialog: {
			set(value) {
				this.$emit('update:showDialog', value);
			},
			get() {
				return this.showDialog;
			},
		},
	},
};
</script>

<style scoped lang="scss">
.delete-contextual-dialog {
	max-width: 650px;
}
</style>
